<template>
    <div>
        <p v-if="error" class="text-danger">{{ errorMsg }}</p>

        <b-table
            v-if="totalRows"
            key="hasMessages"
            responsive
            small
            :busy="loading"
            :items="messageList"
            :fields="messageTableFieldsFiltered"
            :current-page="currentPage"
            :per-page="perPage"
            class="no-top-border"
        >
            <template #cell(vendors)="data">
                {{ data.value }} Vendors
            </template>

            <template #cell(add_to_rfx)="data">
                <span v-if="data.value" key="yes" class="chip chip-success">
                    <b-icon icon="check-circle"></b-icon>
                    Yes
                </span>
                <span v-if="!data.value" key="no" class="chip chip-danger">
                    <b-icon icon="x-circle"></b-icon>
                    No
                </span>                
            </template>

            <template #cell(actions)="data">
                <b-button-group size="sm">
                    <b-button
                        variant="minimal-primary"
                        @click="handleMessageDetails(data.item)"
                    >View</b-button>
                    <!-- <b-button
                        variant="minimal-secondary"
                        @click="handleMessageEdit(data.item)"
                    >Edit</b-button> -->
                    <b-button
                        variant="minimal-danger"
                        @click="handleMessageDelete(data.item)"
                    >Delete</b-button>
                </b-button-group>
            </template>
        </b-table>
        <div v-else key="noMessages" class="text-muted text-center py-3">
            No messages
        </div>
        <div
            v-if="totalRows" 
            class="d-flex justify-content-between align-items-center"
        >
            <div class="text-muted">
                Showing <span class="text-dark">{{startItem}}</span> - <span class="text-dark">{{endItem}}</span> of <span class="text-dark">{{messageList.length}}</span>
            </div>
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="right"
                size="sm"
                class="my-0"
            ></b-pagination>
        </div>
        

        <b-modal
            v-model="showCreateModal"
            scrollable
            centered
            size="lg"
            title="New Update Message"
            hide-footer
            @show="getResponseList"
            @hidden="handleCreateModalHidden"
            body-class="bg-gray-50"
        >
            <div style="">
                <div class="d-flex" style="max-height: 600px;">
                    <div class="mh-100 min-width-200">
                        <div class="p-2 border rounded bg-gray-100 h-100 overflow-auto">
                            <busy-spinner v-if="loadingResponseList" key="vlloading" text="Loading..."></busy-spinner>
                            <div v-else key="vlloaded" class="h-100">
                                <h6>Send Message To:</h6>
                                <div class="d-flex justify-content-around my-75">
                                    <b-link @click="selectAllVendors">
                                        Select All
                                    </b-link>
                                    <b-link @click="unselectAllVendors" class="ml-3">
                                        Unselect All
                                    </b-link>
                                </div>
                                <div class="pl-3">
                                    <b-form-checkbox-group
                                        id="vendor-selection-checkboxes"
                                        v-model="newMessageData.recipient_responses"
                                        :options="responseList"
                                        text-field="vendorName"
                                        value-field="id"
                                        stacked
                                    ></b-form-checkbox-group>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex-fill mh-100 ml-3">
                        <h5>Message</h5>
                        <div class="spl-attribute-labels">
                            <b-form-group
                                id="fieldset-new-message-body"
                                description="This will be visible to vendors"
                                label="Subject"
                                label-for="input-new-message-subject"
                                class="mb-2"
                            >
                                <b-form-input id="input-new-message-subject" v-model="newMessageData.subject" trim></b-form-input>
                            </b-form-group>
                            <b-form-group
                                id="fieldset-new-message-subject"
                                description="The main message body to send"
                                label="Message"
                                label-for="input-new-message-body"
                            >
                                <b-form-textarea id="input-new-message-body" v-model="newMessageData.body" trim rows="10"></b-form-textarea>
                            </b-form-group>
                        </div>
                        <div v-if="!loadingResponseList" class="py-2">
                            <div v-if="newMessageVendorCount" key="hasRecipients" class="">
                                Sending message to <b>{{ newMessageVendorCount }}</b> vendors.
                            </div>
                            <div v-else key="noRecipients" class="text-danger">
                                <b>NOTE:</b> No vendors are selected to receive this message.
                            </div>
                        </div>
                        <div class="py-3 text-center">
                            <div class="mb-3 p-2 border rounded bg-gray-100">
                                <h6 class="text-left">Add Note to RFx Page?</h6>
                                <div class="pl-3">
                                    <b-form-checkbox
                                        id="checkbox-add-to-rfx"
                                        v-model="newMessageData.add_to_rfx"
                                        class="text-left"
                                    >
                                        Yes, add this to the "Updates" section of the RFx page visible to vendors.<br> 
                                        <span class="small text-muted">Any vendor viewing the RFx will then be able to see this update.</span>
                                    </b-form-checkbox>
                                </div>
                            </div>
                            <b-button
                                variant="success"
                                @click="saveMessage"
                                :disabled="!newMessageValid"
                            >
                                Save & Send Message
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>

        <b-modal
            v-model="showDetailModal"
            scrollable
            centered
            size="lg"
            title="View Message"
            hide-footer
            body-class="p-3"
        >
            <div v-if="loadingDetailed" key="detailLoading">
                <busy-spinner></busy-spinner>
            </div>
            <div v-else key="detailLoaded" class="container">
                <div class="row py-4 border-bottom">
                    <div class="col-md-2">
                        <span class="spl-attribute-labels">Date</span>
                    </div>
                    <div class="col-md-10">
                        <div class="font-weight-bold">{{ detailedMessage.created | formatDate }}</div>
                    </div>
                </div>
                <div class="row py-4 border-bottom">
                    <div class="col-md-2">
                        <span class="spl-attribute-labels">Subject</span>
                    </div>
                    <div class="col-md-10">
                        <div class="font-weight-bold">{{ detailedMessage.subject }}</div>
                    </div>
                </div>
                <div class="row py-4 border-bottom">
                    <div class="col-md-2">
                        <span class="spl-attribute-labels">Message</span>
                    </div>
                    <div class="col-md-10">
                        <div class="text-show-breaks">{{ detailedMessage.body }}</div>
                    </div>
                </div>
                <div class="row py-4">
                    <div class="col-md-2">
                        <span class="spl-attribute-labels">Sent To</span>
                    </div>
                    <div class="col-md-10">
                        <div v-if="!detailedMessage.recipient_vendor_names || detailedMessage.recipient_vendor_names.length < 1" key="noVendorRecipients">
                            Not sent to any vendors
                        </div>
                        <div v-else key="hasVendorRecipients" class="">
                            <div class="mb-1">
                                {{ detailedMessage.recipient_vendor_names.length }} vendors
                            </div>
                            <div class="text-muted font-size-80">{{ detailedMessage.recipientVendorNameList }}</div>
                        </div>
                        <div class="mt-3">
                            <span :class="detailedMessage.add_to_rfx ? 'text-success' : 'text-danger'">
                                {{ detailedMessage.add_to_rfx ? 'Was posted to RFx detail page' : 'Not posted to RFx detail page' }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>

    </div>
</template>

<script>
import { suppliosApi } from '../js/api-service';
import { FormatDateHelper } from '../js/filters-helpers';
import cloneDeep from 'lodash/cloneDeep';

export default {
    name: 'RfxBulkMessageList',
    components: {},
    props: {
        rfxPk: {
            type: [String, Number],
            required: true,
        }
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
            loading: false,
            saving: false,
            messageList: [],  // list of past messages
            messageTableFieldsToShow: ['created', 'subject', 'actions'],  // shows/hides the columns below
            messageTableFields: [
                {
                    key: 'created',
                    label: 'Date',
                    formatter: (value) => {
                        return FormatDateHelper(value);
                    },
                },
                {
                    key: 'subject',
                    label: 'Subject',
                },
                {
                    key: 'vendors',
                    label: 'Sent To',
                    formatter: (value) => {
                        return Array.isArray(value) ? value.length : '0';
                    }
                },
                {
                    key: 'add_to_rfx',
                    label: 'Add Update to RFx Page?',
                },
                {
                    key: 'actions',
                    label: 'Actions',
                    class: 'text-center',
                }
            ],
            currentPage: 1,
            perPage: 5,
            showCreateModal: false,  // for showing/hiding create modal
            blankNewMessage: {  // clone this to newMessageData when needed, do not v-model to this
                subject: '',
                body: '',
                add_to_rfx: true,
                send_to_all: true,
                vendors: [],  // should be array of PKs of vendors you want to include - DEPRICATED
                recipient_responses: [],  // USE THIS INSTEAD OF VENDORS
            },
            newMessageData: {},  // clone blankNewMessage and set here
            loadingResponseList: false,
            responseList: [],  // list of vendors on this RFX for possible selection as recipients
            showDetailModal: false,
            loadingDetailed: false, // shows when we're loading detailed message
            detailedMessage: {},  // when we fetch detailed message it goes here
        }
    },
    computed: {
        messageTableFieldsFiltered: function() {
            return this.messageTableFields.filter(field => this.messageTableFieldsToShow.includes(field.key));
        },
        totalRows: function() {
            return this.messageList.length;
        },
        startItem: function() {
            return this.currentPage * this.perPage - this.perPage + 1;
        },
        endItem: function() {
            let maxPossible = this.currentPage * this.perPage;
            if (this.messageList.length < maxPossible) return this.messageList.length;
            return maxPossible;
        },
        newMessageValid: function() {
            // returns Boolean for whether new message is valid or not (form inputs are all valid)
            let subjectValid = !!this.newMessageData.subject;
            let bodyValid = !!this.newMessageData.body;
            let hasRecipients = this.newMessageData.recipient_responses && this.newMessageData.recipient_responses.length > 0;
            let recipientsValid = hasRecipients || this.newMessageData.add_to_rfx;
            return subjectValid && bodyValid && recipientsValid;
        },
        newMessageVendorCount() {
            return (this.newMessageData.recipient_responses && Array.isArray(this.newMessageData.recipient_responses)) ? this.newMessageData.recipient_responses.length : 0;
        },
    },
    filters: {
        formatDate: function(value) {
            return FormatDateHelper(value);
        }
    },
    created: function() {
        this.newMessageData = cloneDeep(this.blankNewMessage);  // get create form fields ready to go
    },
    mounted: function() {
        this.getMessageList();
        // this.getResponseList();  // get on modal show instead
    },
    methods: {
        handleError: function(error, message) {
            console.log(message);
            console.log(error);
            this.errorMsg = message;
            this.error = true;
        },
        getMessageList: function() {
            this.loading = true;
            suppliosApi.rfx.getBulkMessages(this.rfxPk)
            .then(response => {
                console.log('got bulk message list, full response below');
                console.log(response);
                this.messageList = response.data;
            })
            .catch(error => this.handleError(error, 'Error while getting message list'))
            .finally(() => this.loading = false)
        },
        getResponseList: function() {
            // fetch list of responses on this RFX - use it for selecting which vendors receive new message, maybe also as lookup for which ones received existing?
            this.loadingResponseList = true;
            suppliosApi.rfx.getResponses(this.rfxPk)
            .then(response => {
                console.log('got response list with vendors, full response below');
                console.log(response);
                // this will be list of RFX responses but with very limited information - we need vendor name and RfxResponse ID from it to make it match previous format of our vendor list
                this.responseList = response.data.map(resp => {
                    let vendorObj = {};
                    vendorObj['vendorName'] = resp.vendor_name;
                    vendorObj['id'] = resp.pk;  // PK for the RfxResponse obj
                    return vendorObj;
                });
                // NEW - Dec 21 2022 - preselect all vendors as default (so users don't accidentally forget to send to all suppliers)
                // just use the same method you have for clicking 'select all'
                this.selectAllVendors();
            })
            .catch(error => this.handleError(error, 'Error while getting vendor list'))
            .finally(() => this.loadingResponseList = false)
        },
        saveMessage: function() {
            this.saving = true;
            suppliosApi.rfx.createBulkMessage(this.rfxPk, this.newMessageData)
            .then(response => {
                console.log('posted new message, full response below');
                console.log(response);
                this.getMessageList();
                this.showCreateModal = false;  // close the modal
                this.$toast.success('Message saved and sent!');
            })
            .catch(error => this.handleError(error, 'Error while creating new message'))
            .finally(() => this.saving = false)
        },
        startCreateMessage: function() {
            // shows the create modal -- can call this from parent using refs
            this.showCreateModal = true;
        },
        /*
        handleSendToAll: function(whichOne) {
            // handles recipient settings for create new message
            // whichOne is a string, either 'all' or 'select'
            if (whichOne === 'all') {
                this.newMessageData.send_to_all = true;
                this.newMessageData.add_to_rfx = true;
                this.newMessageData.vendors = this.responseList.map(vendor => vendor.id);
            } else if (whichOne === 'select') {
                this.newMessageData.send_to_all = false;
                this.newMessageData.add_to_rfx = false;
            }
        },*/
        selectAllVendors: function() {
            this.newMessageData.recipient_responses = this.responseList.map(vendor => vendor.id);
        },
        unselectAllVendors: function() {
            this.newMessageData.recipient_responses = [];
        },
        handleCreateModalHidden: function() {
            // this gets called anytime create modal is closed -- reset all inputs
            this.newMessageData = cloneDeep(this.blankNewMessage);
        },
        handleMessageEdit: function(messageObj) {
            // open edit modal
            console.log(messageObj);
            
        },
        handleMessageDetails: function(messageObj) {
            // open view modal
            console.log(messageObj);
            this.showDetailModal = true;
            this.getDetailedMessage(messageObj.id);
        },
        handleMessageDelete: function(messageObj) {
            // show confirmation modal
            console.log(messageObj);
            this.$bvModal.msgBoxConfirm('Please confirm that you want to remove this update.  The emails sent to vendors cannot be un-sent.  This only removes the update from the RFX detail page.', {
                title: 'Are you sure?',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'Yes, Remove',
                cancelTitle: 'No, Cancel',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
            .then(value => {
                // value resolves to true if OK is clicked, false if cancel clicked, or null if modal closed
                if (value === true) {
                    this.performMessageDelete(messageObj);
                    console.log("From delete confirm modal, we just called performMessageDelete");
                }
            })
            .catch(error => {
                this.handleError(error, 'There was an error during handleMessageDelete.');
            })
        },
        performMessageDelete: function(messageObj) {
            // actually does the delete via API
            this.loading = true;
            suppliosApi.rfxBulkMessage.remove(messageObj.id)
            .then(response => {
                console.log('removed message via API, full response below');
                console.log(response);
                this.getMessageList();
            })
            .catch(error => this.handleError(error, 'Error while removing message'))
            // no need for finally here... refreshing list will clear loading
        },
        getDetailedMessage: function(messageId) {
            this.loadingDetailed = true;
            /* let axiosConfig = {
                params: {
                    'include[]': 'vendors.*',
                }
            } */
            suppliosApi.rfxBulkMessage.retrieve(messageId)
            .then(response => {
                console.log('got detailed message, response below');
                console.log(response);
                // response has sideloaded stuff, so need to build correct array
                const detailedMessage = cloneDeep(response.data);
                const vendorNames = detailedMessage.recipient_vendor_names;  // should be array of just vendor names
                detailedMessage['recipientVendorNameList'] = (vendorNames && Array.isArray(vendorNames)) ? [...vendorNames].sort().join(', ') : '';
                this.detailedMessage = detailedMessage;  // at the end once we've added all the extra attrs
            })
            .catch(error => this.handleError(error, 'Error while getting details'))
            .finally(() => {
                this.loadingDetailed = false;
            })
        },
    }
}
</script>

<style>
.select-send-to-all {
    border: 2px solid var(--gray-200);
    transition: 0.2s all;
}
.select-send-to-all-handle {
    cursor: pointer;
}
.select-send-to-all:hover {
    background-color: #fff;
    box-shadow: 0 0 4px rgba(0,0,0,0.1);
}
.select-send-to-all.active {
    background-color: #fff;
    border: 2px solid var(--success);
}

#vendor-selection-checkboxes > div {
    margin-bottom: 6px;
    font-weight: 500;
}

</style>